<template>
<section class="breakout-feature px-4 py-10% bg-primary-500 relative">

    <BackgroundImage v-if="background_image" :src="background_image.src" :alt="background_image.alt" opacity="0.5"></BackgroundImage>
    <Burn direction="top" start="0%" end="25%" color="bg-primary-600"></Burn>
    <Burn direction="bottom" start="0%" end="25%" color="bg-primary-600"></Burn>

    <div class="max-w-5xl mx-auto relative z-20">
        <SmoothLoader>

            <img class="featured-image rounded-md mb-8" v-if="featured_image" :src="featured_image.src" :alt="featured_image.alt">
            
            <h2 v-html="headline" class="headline text-white text-4xl vt:text-6xl font-headline font-bold leading-tight mb-8"></h2>
            <div class="prose text-white" v-html="blurb"></div>
            <div v-if="button" class="mt-8">
                <Button :url="button.url" :label="button.label"></Button>
            </div>

        </SmoothLoader>
    </div>
</section>
</template>

<script>
import { ref, computed, onMounted } from 'vue';
export default {
    props: ['data'],
    setup(props) {
        return {
            ...props.data
        }
    }
}
</script>